import { H1, H3, Paragraph, Spinner, Text, XStack, YStack } from 'tamagui';
import { Screen } from '@mrrmlab/ui';
import type { RoadmapRelease } from '@mrrmlab/api-client';
import { useRoadmap } from '../roadmap/hooks';

export function RoadmapRoute() {
  const { data, isLoading, isError } = useRoadmap();

  if (isLoading) {
    return (
      <Screen alignItems="center" justifyContent="center">
        <Spinner size="large" />
      </Screen>
    );
  }

  if (isError || !data) {
    return (
      <Screen>
        <Text color="$red10">Roadmap konnte nicht geladen werden.</Text>
      </Screen>
    );
  }

  const done = data.releases
    .filter((r) => r.status === 'done')
    .sort((a, b) => b.date.localeCompare(a.date));

  const planned = data.releases
    .filter((r) => r.status === 'next')
    .sort((a, b) => a.date.localeCompare(b.date));

  return (
    <Screen scrollable>
      <H1>Roadmap & Changelog</H1>

      {planned.length > 0 && (
        <YStack gap="$4">
          <H3 color="$blue10">Geplant</H3>
          {planned.map((release) => (
            <ReleaseCard key={release.tag} release={release} />
          ))}
        </YStack>
      )}

      <YStack gap="$4">
        <H3>Changelog</H3>
        {done.map((release) => (
          <ReleaseCard key={release.tag} release={release} />
        ))}
      </YStack>
    </Screen>
  );
}

function ReleaseCard({ release }: { release: RoadmapRelease }) {
  return (
    <YStack
      borderWidth={1}
      borderColor="$borderColor"
      borderRadius="$4"
      padding="$4"
      gap="$2"
      backgroundColor="$background"
    >
      <XStack alignItems="center" gap="$2" flexWrap="wrap">
        <Text fontSize="$3" color="$color10" fontFamily="$mono">
          {release.tag}
        </Text>
        <Text fontSize="$2" color="$color8">
          {release.date}
        </Text>
        {release.status === 'next' && (
          <YStack
            backgroundColor="$blue5"
            paddingHorizontal="$2"
            paddingVertical="$1"
            borderRadius="$2"
          >
            <Text fontSize="$1" color="$blue10" fontWeight="600">
              Geplant
            </Text>
          </YStack>
        )}
      </XStack>
      <Text fontSize="$5" fontWeight="700">
        {release.title}
      </Text>
      <Paragraph color="$color11">{release.summary}</Paragraph>
      {release.highlights.length > 0 && (
        <YStack gap="$1" marginTop="$1">
          {release.highlights.map((h, i) => (
            <XStack key={i} gap="$2">
              <Text color="$color9">•</Text>
              <Text fontSize="$3" color="$color10" flex={1}>
                {h}
              </Text>
            </XStack>
          ))}
        </YStack>
      )}
    </YStack>
  );
}
